var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center",class:'badge badge-' + _vm.badgeType},[(_vm.isOut)?_c('arrow-up-right',{staticClass:"mr-2"}):_c('arrow-down-left',{staticClass:"mr-2"}),_c('amount-badge',{attrs:{"type":_vm.type,"amount":_vm.amount,"symbol":_vm.symbol}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }